export const PLATFORM_TRADE_VOLUME_PAGE_UUID =
  'bc2dcde0-6d5c-4982-88bd-2c87254d93e8'
